/**
 * Single source of truth for which advantage cards render.
 *
 * The sticky-nav anchor and the panel BOTH derive from this, so the ADVANTAGES nav entry
 * exists iff at least one card renders. Computing the two independently is what produced
 * the ghost-section bug: the nav gated on `isDealerSubscription` (seller pack) while the
 * cards gate on `isSubscriptionAd` (ad renting fee), and those two disagree whenever a
 * renting-pack dealer lists a non-renting ad, or vice versa.
 *
 * The three predicates mirror legacy `variants/legacy/index.js:1448,1449,1453` and must not
 * drift from them — legacy is the behavioural reference for card visibility.
 */
const getAdvantagesVisibility = ({ad = {}, adType = {}, vehicleHistory, config}) => {
  const {
    SERVICE_PROVIDERS: {CARFAX}
  } = config.get('COMMON')
  // serviceProviders is `{}` on motos, so AVAILABLE_SERVICE_PROVIDERS must be reached defensively
  const {AVAILABLE_SERVICE_PROVIDERS} = config.get('serviceProviders') ?? {}
  const {OFFER_TYPE_NEW} = config.get('search')
  const {IS_INSTANT_OFFER_FEATURE_ENABLED} = config.get('seller')

  const isSubscriptionAd = Boolean(ad.monthlySubscriptionFee)
  const isNewVehicle = adType.offerTypeId === OFFER_TYPE_NEW

  const showInsurance = !isSubscriptionAd
  const showCarfax =
    Boolean(AVAILABLE_SERVICE_PROVIDERS?.[CARFAX]) &&
    !isSubscriptionAd &&
    !isNewVehicle &&
    Boolean(vehicleHistory) &&
    !vehicleHistory.hasReport
  const showSellVehicle = Boolean(IS_INSTANT_OFFER_FEATURE_ENABLED) && Boolean(ad.isProfessional) && !isSubscriptionAd

  return {
    showInsurance,
    showCarfax,
    showSellVehicle,
    showAdvantages: showInsurance || showCarfax || showSellVehicle
  }
}

export default getAdvantagesVisibility
